<template>
  <div :class="cl(null, 'container-fluid job-list-service')">
    <div class="row">
      <div v-if="cols[0]" :class="cl('id', `col `)">
        <slot
          v-if="job.status != 1 && (baseLinkUrl || baseLinkDate) && !insideJob"
          name="joblink"
          :job="job"
          :insidejob="insideJob"
          style="cursor: pointer;"
        >
          <a
            v-if="job.status != 1 && (baseLinkUrl || baseLinkDate)"
            :href="`${baseLinkUrl ? baseLinkUrl : baseLinkDate}/${job.id}`"
            style="cursor: pointer;"
          >
            {{ job.id_extern }}
          </a>
        </slot>
        <span v-else>{{ job.id_extern }} </span>
        <div v-if="managerId && job.manager_id">
          <img
            :src="
              job.manager.profile && job.manager.profile.picture
                ? job.manager.profile.picture
                : ''
            "
            width="25"
          />
          <small class="d-block mt-xxs">{{ job.manager.nameShort }}</small>
        </div>

        <img
          v-if="job.icon"
          :src="getIconSrc(job.icon)"
          :class="cl('icon', job.iconClass)"
        />
      </div>
<!-- 
      <div v-if="cols[0]" :class="cl('id', `col col-1`)">
        <slot
          v-if="job.status != 1 && (baseLinkUrl || baseLinkDate) && !insideJob"
          name="jobname"
          :job="job"
          :insidejob="insideJob"
        >
          <a
            v-if="job.status != 1 && (baseLinkUrl || baseLinkDate)"
            :href="`${baseLinkUrl ? baseLinkUrl : baseLinkDate}/${job.id}`"
            style="cursor: pointer;"
          >
            {{ job.name }}
          </a>
        </slot>
        <span v-else>{{ job.name }} </span>
      </div> -->

      <div v-if="cols[1]" :class="`col ${cols[1]}`">
        <ul :class="cl('locations', 'list-reset')">
          <li
            v-for="(location, locationKey) in job.locations"
            :key="locationKey"
            :class="cl('location')"
          >
          
            <p v-if="job.name">{{ job.name }}</p>
            {{ location.address }}
          </li>
        </ul>

        <ul
          v-for="(typeCategories, typeKey) in job.partsGrouped"
          :key="typeKey"
          :class="cl('parts', 'list-reset')"
        >
          <li
            v-for="(categoryFloors, categoryKey) in typeCategories"
            :key="categoryKey"
            :class="cl('part')"
          >
            <span :class="cl('part__type')">
              <img :src="getIconSrc(`${typeKey}_${categoryKey}`)" />
              <span>{{ __(`jobs.common.parts.types.${typeKey}`) }}</span>
            </span>
            <span :class="cl('part__amount')">
              {{ getCategoryPartsAmount(categoryFloors) }}
              {{
                __(
                  `jobs.common.parts.categories.${typeKey}.${categoryKey}`,
                  getCategoryPartsAmount(categoryFloors)
                )
              }}
            </span>
          </li>
        </ul>
      </div>

      <div v-if="cols[2]" :class="`col ${cols[2]}`">
        <div class="d-flex">
          <div class="flex-grow-1">
            <button
              v-if="job.period_planned"
              :class="cl('planned btn-plain')"
              @click="$emit('planned-clicked', job)"
              style="color: #111"
            >
              {{ periodOutput }}
            </button>

            <ul
              :class="cl('dates', 'list-reset')"
              v-if="job.dates && job.dates.length"
            >
              <li v-for="(date, dateKey) in job.dates" :key="dateKey">
                <div
                  :class="
                    cl('date', ['row'].concat(date.classes || []).join(' '))
                  "
                >
                  <div
                    :class="{
                      col: true,
                      'col-7': !(
                        'column-infos' in $slots ||
                        'column-infos' in $scopedSlots
                      ),
                    }"
                  >
                    <slot name="date-item" :date="date">
                      <job-list-date-item
                        :date="date"
                        @date-clicked="$emit('date-clicked', $event)"
                      >
                        <template v-for="(_, name) in $slots">
                          <slot
                            v-if="name != 'default'"
                            :name="name"
                            :slot="name"
                          />
                        </template>
                        <template
                          v-for="(_, name) in $scopedSlots"
                          :slot="name"
                          slot-scope="slotData"
                        >
                          <slot
                            v-if="name != 'default'"
                            :name="name"
                            v-bind="slotData"
                          />
                        </template>
                      </job-list-date-item>
                    </slot>
                  </div>
                  <div
                    v-if="
                      !(
                        'column-infos' in $slots ||
                        'column-infos' in $scopedSlots
                      )
                    "
                    :class="cl('date__technician', 'col col-5 pl-0')"
                  >
                    <slot
                      name="column-date-info"
                      :job="job"
                      :date="date"
                      :cl="cl"
                    >
                      <span v-if="date.technician" class="v-center-inline">
                        <img
                          :src="getIconSrc('check-circle-green.svg')"
                          width="15"
                        />
                        <a
                          :href="
                            getTechnicianUrl
                              ? getTechnicianUrl(date.technician)
                              : undefined
                          "
                          :is="getTechnicianUrl ? 'a' : 'span'"
                        >
                          {{
                            date.technician.profile
                              ? date.technician.nameShort
                                ? date.technician.nameShort
                                : date.technician.profile.firstname +
                                  " " +
                                  date.technician.profile.lastname
                              : date.technician.nameShort
                          }}
                        </a>
                      </span>
                      <span
                        v-else-if="
                          !date.technician_requests ||
                          date.technician_requests.length == 0
                        "
                        class="job-list__job__date__technician--open"
                      >
                        {{ __("main.common.open") }}
                      </span>
                      <span
                        v-else-if="
                          date.technician_requests.every((p) => p.status == 3)
                        "
                        @mouseenter="
                          popover = { target: $event.target, data: date }
                        "
                        @mouseleave="popover = null"
                        class="v-center-inline"
                      >
                        <img
                          :src="getIconSrc('cross-circle-red.svg')"
                          width="15"
                        />
                        <span>Abgelehnt</span>
                      </span>
                      <span
                        v-else-if="date.technician_requests.every((p) => checkDate(p.updated_at, p.acceptance_period))"
                        @mouseenter="
                          popover = { target: $event.target, data: date }
                        "
                        @mouseleave="popover = null"
                        class="v-center-inline"
                      >
                        <img
                          :src="getIconSrc('cross-circle-red.svg')"
                          width="15"
                        />
                        <span>Abgelaufen</span>
                      </span>
                      <span
                        v-else
                        @mouseenter="
                          popover = { target: $event.target, data: date }
                        "
                        @mouseleave="popover = null"
                        class="v-center-inline"
                      >
                        <img
                          :src="getIconSrc('question-mark.svg')"
                          width="15"
                        />
                        <span>
                          Angefragt</span>
                      </span>
                    </slot>
                  </div>
                </div>
              </li>
            </ul>
            <p v-else><i>Noch keine Termine</i></p>
          </div>

          <div
            :class="cl('infos', 'flex-grow-1 flex-shrink-1')"
            v-if="'column-infos' in $slots || 'column-infos' in $scopedSlots"
          >
            <slot name="column-infos" :job="job" :cl="cl"></slot>
          </div>
        </div>
      </div>

      <div v-if="cols[1]" :class="`col ${cols[1]} text-right`">
        <span class="d-none">{{ job.status }}</span>
        <slot :name="`button-status-${job.status}`" :job="job">
          <slot name="button" :job="job"></slot>
        </slot>
      </div>
    </div>

    <popover
      v-if="popover"
      :target="popover.target"
      :close-btn="false"
      position="bottom-start"
    >
      <ul>
        <li
          v-for="(request, requestTecKey) in popover.data.technician_requests"
          :key="requestTecKey"
        >
          {{
            request.technician.name +
            (request.reason ? `: ${request.reason.reason}` : "")
          }}
        </li>
      </ul>
    </popover>
    <popover
      v-if="job.iconPopover"
      key="popover-job-icon"
      :target="`.${cl('icon', '', false)}`"
      relative-to="$parent"
      position="bottom-start"
      :show-on-mounted="false"
      :show-on-updated="false"
      :toggle-on="['click', 'mouseenter', 'mouseleave']"
      :toggle-on-target="iconPopoverToggleTarget"
      :hide-on-outside-click="true"
    >
      <div v-html="job.iconPopover"></div>
    </popover>
  </div>
</template>

<script>
import NeedsIcons from "../Mixins/NeedsIcons";
import NeedsTranslations from "../Mixins/NeedsTranslations";

export default {
  mixins: [NeedsIcons, NeedsTranslations],
  inject: {
    baseLinkUrl: { default: null },
    managerId: { default: null },
    getTechnicianUrl: { default: null },
  },
  props: {
    baseLinkDate: {
      default: null,
    },
    job: {
      type: Object,
      required: true,
    },
    baseClass: {
      type: String,
      default: "job-list-item",
    },
    additionalBaseClass: {
      type: String,
    },
    groupBy: {
      type: String,
      default: "category",
    },
    iconPopoverToggleTarget: {
      type: String,
    },
    showButtons: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      popover: null,
      insideJob: null,
    };
  },
  mounted() {
    let pathname = window.location.pathname.split("/");
    let url = "/" + pathname[1] + "/" + pathname[2];
    url == this.baseLinkUrl
      ? (this.insideJob = true)
      : (this.insideJob = false);
  },
  computed: {
    periodOutput() {
      let output = [];
      let plannedPeriod = this.job.period_planned;
      let years =
        "y" in plannedPeriod ? plannedPeriod.y : [new Date().getFullYear()];

      Object.entries({
        w: {
          translation: this.__("main.common.calendar_week") + " ",
          twoDigits: true,
        },
        q: { translation: this.__("main.common.quarter"), twoDigits: false },
      }).every(([key, params]) => {
        if (key in plannedPeriod) {
          let periods = [plannedPeriod[key][0]];

          if (plannedPeriod[key].length > 1) {
            periods.push(plannedPeriod[key][plannedPeriod.w.length - 1]);
          }

          periods.forEach((period, index) => {
            let prefix = index == 0 ? params.translation : "";
            let periodOutput =
              !params.twoDigits || period >= 10
                ? period
                : "0" + period.toString();
            let yearOutput =
              years.length > index
                ? years[index].toString().substr(2)
                : years[0].toString().substr(2);
            output.push(`${prefix}${periodOutput} / ${yearOutput}`);
          });

          return false;
        }

        return true;
      });

      return output.join(" - ");
    },
    cols() {
      return this.showButtons
        ? ["col-1", "col-3", "col-5", "col-3", "col-2"]
        : ["col-1 pr-0", "col-4", "col-6"];
    },
  },
  methods: {
    getCategoryPartsAmount(categoryGroup) {
      return Object.values(categoryGroup).reduce((amount, group) => {
        return amount + group.length;
      }, 0);
    },
    cl(subClass, additionalClasses = "", useAdditionalBaseClasses = true) {
      let className = this.baseClass + (subClass ? "__" + subClass : "");

      if (useAdditionalBaseClasses && this.additionalBaseClass) {
        className +=
          " " + this.additionalBaseClass + (subClass ? "__" + subClass : "");
      }

      return className + " " + additionalClasses;
    },

    checkDate(data, addHours){
      const date = new Date(data);
      const currentDate = new Date();

      const numOfHours = addHours;
      date.setTime(date.getTime() + numOfHours * 60 * 60 * 1000);

      return date < currentDate
    }
  },
};
</script>